import { Box } from '@mui/material'

export const Steps = [
    {
        target: '.step-one',
        content: (
            <>
               <Box display="flex" justifyContent="space-between">
                    <Box fontSize={16} fontWeight="bold" color="#0070EF">Dashboard</Box>
                    <Box fontSize={12} color="#A2A2A2"> 1 of 10</Box>
                </Box>
                <Box fontSize={12} mt={2} color="#1B1B1B" textAlign="left">Your transaction summary. </Box>
            </>
        ),
        disableBeacon : true,
        placement: "top",
    },
    {
        target: '.step-two',
        content: (
            <>
               <Box display="flex" justifyContent="space-between">
                    <Box fontSize={16} fontWeight="bold" color="#0070EF">Services</Box>
                    <Box fontSize={12} color="#A2A2A2"> 2 of 10</Box>
                </Box>
                <Box fontSize={12} mt={2} color="#1B1B1B" textAlign="left">Booking and Training services promo.</Box>
            </>
        ),
        disableBeacon : true,
        placement: "top",
    },
    {
        target: '.step-three',
        content: (
            <>
               <Box display="flex" justifyContent="space-between">
                    <Box fontSize={16} fontWeight="bold" color="#0070EF">Shop</Box>
                    <Box fontSize={12} color="#A2A2A2"> 3 of 10</Box>
                </Box>
                <Box fontSize={12} mt={2} color="#1B1B1B" textAlign="left">Purchase your goods and products.</Box>
            </>
        ),
        disableBeacon : true,
        placement: "top",
    },
    {
        target: '.step-four',
        content: (
            <>
               <Box display="flex" justifyContent="space-between">
                    <Box fontSize={16} fontWeight="bold" color="#0070EF">Real Property</Box>
                    <Box fontSize={12} color="#A2A2A2"> 4 of 10</Box>
                </Box>
                <Box fontSize={12} mt={2} color="#1B1B1B" textAlign="left">Real estate you can buy, sell, or lease.”</Box>
            </>
        ),
        disableBeacon : true,
        placement: "top",
    },
    {
        target: '.step-five',
        content: (
            <>
               <Box display="flex" justifyContent="space-between">
                    <Box fontSize={16} fontWeight="bold" color="#0070EF">More</Box>
                    <Box fontSize={12} color="#A2A2A2"> 5 of 10</Box>
                </Box>
                <Box fontSize={12} mt={2} color="#1B1B1B" textAlign="left">You can access more features and settings here.</Box>
            </>
        ),
        disableBeacon : true,
        placement: "top",
    },
    {
        target: '.step-six',
        content: (
            <>
               <Box display="flex" justifyContent="space-between">
                    <Box fontSize={16} fontWeight="bold" color="#0070EF">Cart</Box>
                    <Box fontSize={12} color="#A2A2A2"> 6 of 10</Box>
                </Box>
                <Box fontSize={12} mt={2} color="#1B1B1B" textAlign="left">Review and manage your selected items before checkout.</Box>
            </>
        ),
        disableBeacon : true,
        placement: "bottom",
    },
    {
        target: '.step-seven',
        content: (
            <>
               <Box display="flex" justifyContent="space-between">
                    <Box fontSize={16} fontWeight="bold" color="#0070EF">Holy Bible</Box>
                    <Box fontSize={12} color="#A2A2A2"> 7 of 10</Box>
                </Box>
                <Box fontSize={12} mt={2} color="#1B1B1B" textAlign="left">Daily Guide Words.</Box>
            </>
        ),
        disableBeacon : true,
        placement: "bottom",
    },
    {
        target: '.step-eight',
        content: (
            <>
               <Box display="flex" justifyContent="space-between">
                    <Box fontSize={16} fontWeight="bold" color="#0070EF">Chat</Box>
                    <Box fontSize={12} color="#A2A2A2"> 8 of 10</Box>
                </Box>
                <Box fontSize={12} mt={2} color="#1B1B1B" textAlign="left">Switch to POFChat Personal.</Box>
            </>
        ),
        disableBeacon : true,
        placement: "bottom",
    },
    {
        target: '.step-nine',
        content: (
            <>
               <Box display="flex" justifyContent="space-between">
                    <Box fontSize={16} fontWeight="bold" color="#0070EF">Notification</Box>
                    <Box fontSize={12} color="#A2A2A2"> 9 of 10</Box>
                </Box>
                <Box fontSize={12} mt={2} color="#1B1B1B" textAlign="left">This hold your notification.</Box>
            </>
        ),
        disableBeacon : true,
        placement: "bottom",
    },
    {
        target: '.step-ten',
        content: (
            <>
               <Box display="flex" justifyContent="space-between">
                    <Box fontSize={16} fontWeight="bold" color="#0070EF">My Tools</Box>
                    <Box fontSize={12} color="#A2A2A2"> 10 of 10</Box>
                </Box>
                <Box fontSize={12} mt={2} color="#1B1B1B" textAlign="left">Access your availed tool here.</Box>
            </>
        ),
        disableBeacon : true,
        placement: "left",
    },
    
]

export const BookingSteps = [
    {
        target: '.one',
        content: (
            <>
               <Box display="flex" justifyContent="space-between">
                    <Box fontSize={12} fontWeight="bold" color="#556D8D">Click here to begin your booking.</Box>
                    {/* <Box fontSize={12} color="#A2A2A2"> 1 of 9</Box> */}
                </Box>
                <Box fontSize={12} mt={2} color="#333333" textAlign="left">Provide your personal information and proceed with the secure online payment.</Box>
            </>
        ),
        disableBeacon : true,
        placement: "top",
    },
    {
        target: '.two',
        content: (
            <>
               <Box display="flex" justifyContent="space-between">
                    <Box fontSize={14} fontWeight="bold" color="#556D8D">My Booking</Box>
                    {/* <Box fontSize={12} color="#A2A2A2"> 2 of 9</Box> */}
                </Box>
                <Box fontSize={12} mt={2} color="#333333" textAlign="left">View all your previous booking transactions here.</Box>
            </>
        ),
        disableBeacon : true,
        placement: "top",
    },
]

export const TrainingSteps = [
    {
        target: '.one',
        content: (
            <>
               <Box display="flex" justifyContent="space-between">
                    <Box fontSize={12} fontWeight="bold" color="#556D8D">Click here to begin your training.</Box>
                    {/* <Box fontSize={12} color="#A2A2A2"> 1 of 9</Box> */}
                </Box>
                <Box fontSize={12} mt={2} color="#333333" textAlign="left">Provide your personal information and proceed with the secure online payment.</Box>
            </>
        ),
        disableBeacon : true,
        placement: "top",
    },
    {
        target: '.two',
        content: (
            <>
               <Box display="flex" justifyContent="space-between">
                    <Box fontSize={14} fontWeight="bold" color="#556D8D">My Training</Box>
                    {/* <Box fontSize={12} color="#A2A2A2"> 2 of 9</Box> */}
                </Box>
                <Box fontSize={12} mt={2} color="#333333" textAlign="left">View all your previous training transactions here.</Box>
            </>
        ),
        disableBeacon : true,
        placement: "top",
    },
]

export const ProductSteps = [
    {
        target: '.one',
        content: (
            <>
               <Box display="flex" justifyContent="space-between">
                    <Box fontSize={12} fontWeight="bold" color="#556D8D">Click here to begin your Product.</Box>
                    {/* <Box fontSize={12} color="#A2A2A2"> 1 of 9</Box> */}
                </Box>
                <Box fontSize={12} mt={2} color="#333333" textAlign="left">Provide your personal information and proceed with the secure online payment.</Box>
            </>
        ),
        disableBeacon : true,
        placement: "top",
    },
    {
        target: '.two',
        content: (
            <>
               <Box display="flex" justifyContent="space-between">
                    <Box fontSize={14} fontWeight="bold" color="#556D8D">My Orders</Box>
                    {/* <Box fontSize={12} color="#A2A2A2"> 2 of 9</Box> */}
                </Box>
                <Box fontSize={12} mt={2} color="#333333" textAlign="left">View all your previous product transactions here.</Box>
            </>
        ),
        disableBeacon : true,
        placement: "top",
    },
]